const Loader = ({ pageLoader, style }) => {
  
  if (!pageLoader) return null;

  return (
    <div
      className="fixed inset-0 z-[1050] flex items-center justify-center bg-black/40"
      style={style}
    >
      <div
        className="w-9 h-9 border-4 border-darkSpinner border-t-transparent rounded-full animate-spin"
      />
      <span className="sr-only">Loading...</span>
    </div>
  );
};

export default Loader;
